import { RefObject, useState } from 'react'
import { callRudderEventForBookingCTAclicked } from 'app/ProviderSearch/rudderEventUtils'
import styles from './index.module.scss'
import { BookingButtonLocation } from 'app/Bookings/constants'
import useBreakpoint from 'hooks/useBreakPoint'
import logEvent from 'utils/logEvent'
import { RudderEvent } from 'constants/rudderEvents'
import { useRouter } from 'next/router'
import { pageRoutes } from 'constants/routing'
import { useSpring, useScroll, animated } from '@react-spring/web'
import { Button } from 'component_library/1_Atoms'
import { seFriendlyPhoneNumber } from 'app/SeFriendly/constants'

type CallNowBookOnlineStickyProps = {
  pageContainerRef: RefObject<HTMLDivElement>
  phoneNumber?: string
}

const CallNowBookOnlineStickyCTA: React.FC<CallNowBookOnlineStickyProps> = ({
  pageContainerRef,
  phoneNumber = seFriendlyPhoneNumber.phoneNumber,
}) => {
  const [isCTAvisible, setIsCTAvisible] = useState<boolean>(false)

  const { isMobileScreen } = useBreakpoint()
  const router = useRouter()

  const springs = useSpring({
    y: isCTAvisible ? 0 : 100,
  })

  useScroll({
    onChange: ({ value: { scrollY } }) => {
      if (scrollY > pageContainerRef.current.clientHeight) {
        setIsCTAvisible(true)
      } else {
        setIsCTAvisible(false)
      }
    },
  })

  const onBookOnline = (event) => {
    router.push(pageRoutes.PROVIDER_SEARCH)
    callRudderEventForBookingCTAclicked(
      BookingButtonLocation.MOBILE_STICKY_CTA_BAR,
      (event.currentTarget as HTMLElement).className,
      (event.currentTarget as HTMLElement).innerText
    )
  }

  const onCallNow = () => {
    window.location.href = `tel:${phoneNumber}`

    logEvent(RudderEvent.PHONE_NUMBER_CLICKED, {
      phone_number: seFriendlyPhoneNumber.formattedPhoneNumber,
    })
  }

  if (!isMobileScreen) {
    return null
  }

  return (
    <animated.div style={springs} className={styles.sticky_cta_btn_container}>
      <Button full theme="v2" onClick={onBookOnline}>
        Book online
      </Button>

      <Button full variant="quinary" theme="v2" onClick={onCallNow}>
        Call now
      </Button>
    </animated.div>
  )
}

export default CallNowBookOnlineStickyCTA
